/**
 * UserOauth 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * UserOauth
 */
export interface UserOauth {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键（UUID4），全局唯一，不可重复，36位 */
  id?: string
  /** Google平台的唯一用户ID */
  google_id?: string
  /** Google平台返回的邮箱 */
  google_email?: string
  /** Google平台返回的用户名 */
  google_name?: string
  /** Google平台返回的头像URL */
  google_avatar?: string
  /** Google访问令牌 */
  google_access_token?: string
  /** Google刷新令牌 */
  google_refresh_token?: string
  /** Google Token过期时间（UTC） */
  google_token_expire_at?: string
  /** Google绑定时间（UTC） */
  google_bound_at?: string
  /** Google最后登录时间（UTC） */
  google_last_login_at?: string
  /** Apple平台的唯一用户ID */
  apple_id?: string
  /** Apple平台返回的邮箱 */
  apple_email?: string
  /** Apple平台返回的用户名 */
  apple_name?: string
  /** Apple平台返回的头像URL */
  apple_avatar?: string
  /** Apple访问令牌 */
  apple_access_token?: string
  /** Apple刷新令牌 */
  apple_refresh_token?: string
  /** Apple Token过期时间（UTC） */
  apple_token_expire_at?: string
  /** Apple绑定时间（UTC） */
  apple_bound_at?: string
  /** Apple最后登录时间（UTC） */
  apple_last_login_at?: string
  /** Facebook平台的唯一用户ID */
  facebook_id?: string
  /** Facebook平台返回的邮箱 */
  facebook_email?: string
  /** Facebook平台返回的用户名 */
  facebook_name?: string
  /** Facebook平台返回的头像URL */
  facebook_avatar?: string
  /** Facebook访问令牌 */
  facebook_access_token?: string
  /** Facebook刷新令牌 */
  facebook_refresh_token?: string
  /** Facebook Token过期时间（UTC） */
  facebook_token_expire_at?: string
  /** Facebook绑定时间（UTC） */
  facebook_bound_at?: string
  /** Facebook最后登录时间（UTC） */
  facebook_last_login_at?: string
}

/**
 * UserOauth Schema
 */
export const UserOauthSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键（UUID4），全局唯一，不可重复，36位',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    google_id: {
      description: 'Google平台的唯一用户ID',
      format: 'string',
      type: 'string',
      label: 'Google平台的唯一用户ID',
    },
    google_email: {
      description: 'Google平台返回的邮箱',
      format: 'string',
      type: 'string',
      label: 'Google平台返回的邮箱',
    },
    google_name: {
      description: 'Google平台返回的用户名',
      format: 'string',
      type: 'string',
      label: 'Google平台返回的用户名',
    },
    google_avatar: {
      description: 'Google平台返回的头像URL',
      format: 'string',
      type: 'string',
      label: 'Google平台返回的头像URL',
    },
    google_access_token: {
      description: 'Google访问令牌',
      format: 'string',
      type: 'string',
      label: 'Google访问令牌',
    },
    google_refresh_token: {
      description: 'Google刷新令牌',
      format: 'string',
      type: 'string',
      label: 'Google刷新令牌',
    },
    google_token_expire_at: {
      description: 'Google Token过期时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: 'Google',
    },
    google_bound_at: {
      description: 'Google绑定时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: 'Google绑定时间',
    },
    google_last_login_at: {
      description: 'Google最后登录时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: 'Google最后登录时间',
    },
    apple_id: {
      description: 'Apple平台的唯一用户ID',
      format: 'string',
      type: 'string',
      label: 'Apple平台的唯一用户ID',
    },
    apple_email: {
      description: 'Apple平台返回的邮箱',
      format: 'string',
      type: 'string',
      label: 'Apple平台返回的邮箱',
    },
    apple_name: {
      description: 'Apple平台返回的用户名',
      format: 'string',
      type: 'string',
      label: 'Apple平台返回的用户名',
    },
    apple_avatar: {
      description: 'Apple平台返回的头像URL',
      format: 'string',
      type: 'string',
      label: 'Apple平台返回的头像URL',
    },
    apple_access_token: {
      description: 'Apple访问令牌',
      format: 'string',
      type: 'string',
      label: 'Apple访问令牌',
    },
    apple_refresh_token: {
      description: 'Apple刷新令牌',
      format: 'string',
      type: 'string',
      label: 'Apple刷新令牌',
    },
    apple_token_expire_at: {
      description: 'Apple Token过期时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: 'Apple',
    },
    apple_bound_at: {
      description: 'Apple绑定时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: 'Apple绑定时间',
    },
    apple_last_login_at: {
      description: 'Apple最后登录时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: 'Apple最后登录时间',
    },
    facebook_id: {
      description: 'Facebook平台的唯一用户ID',
      format: 'string',
      type: 'string',
      label: 'Facebook平台的唯一用户ID',
    },
    facebook_email: {
      description: 'Facebook平台返回的邮箱',
      format: 'string',
      type: 'string',
      label: 'Facebook平台返回的邮箱',
    },
    facebook_name: {
      description: 'Facebook平台返回的用户名',
      format: 'string',
      type: 'string',
      label: 'Facebook平台返回的用户名',
    },
    facebook_avatar: {
      description: 'Facebook平台返回的头像URL',
      format: 'string',
      type: 'string',
      label: 'Facebook平台返回的头像URL',
    },
    facebook_access_token: {
      description: 'Facebook访问令牌',
      format: 'string',
      type: 'string',
      label: 'Facebook访问令牌',
    },
    facebook_refresh_token: {
      description: 'Facebook刷新令牌',
      format: 'string',
      type: 'string',
      label: 'Facebook刷新令牌',
    },
    facebook_token_expire_at: {
      description: 'Facebook Token过期时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: 'Facebook',
    },
    facebook_bound_at: {
      description: 'Facebook绑定时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: 'Facebook绑定时间',
    },
    facebook_last_login_at: {
      description: 'Facebook最后登录时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: 'Facebook最后登录时间',
    },
  },
  type: 'object',
}
